import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCommits: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCommits"><Circle cx="12" cy="12" r="5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M6.5 12H1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M22.25 12H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCommits;
